import { Component } from '@angular/core';
import {NbDialogService, NbMenuService, NbSidebarService, NbThemeService} from "@nebular/theme";
import {AuthService} from "@app/service/auth.service";
import {OktaAuthService} from "@okta/okta-angular";
import {Router} from "@angular/router";
import {environment} from "@env";
const issuer = environment.OKTA_ISSUER;
const redirectUri = `${window.location.origin}`;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  constructor(
      private themeService: NbThemeService,
      public authService: AuthService,
      private nbMenuService: NbMenuService,
      private sidebarService: NbSidebarService,
      private dialogService: NbDialogService,
      public oktaAuth: OktaAuthService,
      private router: Router
  ) {}
  public isAuthenticated = this.authService.getUser() !== null;
  async ngOnInit() {

    this.isAuthenticated = await this.oktaAuth.isAuthenticated();
     // Subscribe to authentication state changes
    this.oktaAuth.$authenticationState.subscribe((isAuthenticated: boolean) => {
      this.isAuthenticated = isAuthenticated;

    });

  }
  async logout() {
    if (confirm("Are you sure you want to log out?")) {
      const idToken = await this.oktaAuth.getIdToken();
      await this.oktaAuth.logout("/");
      window.location.href = `${issuer}/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${redirectUri}`;

    }
  }

    goPage() {
        this.router.navigate(['/corporate/home']);
    }
}


